import TravelRecentArticles from './TravelRecentArticles';

export default TravelRecentArticles;
